// extracted by mini-css-extract-plugin
module.exports = {"orderReviewBasicSettings":"orderReviewBasicSettings___rJLwZ","isMobile":"isMobile___gP5kA","settingDisable":"settingDisable___31DAT"};